// extracted by mini-css-extract-plugin
export default {"headerview":"a8cb15639aa4143138ef","navbar":"a0831c9474ad62362212"};